import { render, staticRenderFns } from "./survey-detail.vue?vue&type=template&id=b19561f4&scoped=true&"
import script from "./survey-detail.vue?vue&type=script&lang=js&"
export * from "./survey-detail.vue?vue&type=script&lang=js&"
import style0 from "./survey-detail.vue?vue&type=style&index=0&id=b19561f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19561f4",
  null
  
)

export default component.exports